// Define the base URL for the API from environment variables
const BASE_URL = process.env.REACT_APP_API_URL;

// Define the API routes object
const apiRoutes = {
  // Routes related to applications
  apps: {
    // Route to get all applications
    saveAppData: `${BASE_URL}/admin/updateapps`,
    adminapps: `${BASE_URL}/admin/apps`,
    parentapps: `${BASE_URL}/admin/parentsapp`,
    getAppsPA: (paid: string) => `${BASE_URL}/admin/appbypa/${paid}`,
    getAllApps: (okta_id: string) => `${BASE_URL}/apps/parentapps/${okta_id}`,
    saveParenApp: `${BASE_URL}/parent-apps/save`,
    saveApp: `${BASE_URL}/apps/save`,
    // Route to get applications by a specific user ID
    getAppsByUser: `${BASE_URL}/userapps`,
    sidebar: `${BASE_URL}/sidebar`,
    searchPAApps: `${BASE_URL}/search`,
  },

  // Routes related to user information
  user: {
    // Route to get user data
    datauser: `${BASE_URL}/users/`,
    updateSettings: `${BASE_URL}/settings/update`,
    settings: `${BASE_URL}/settings`,
  },

  // Routes related to favorite items
  favorites: {
    // Route to toggle favorite status
    toggle: `${BASE_URL}/favorites`,
  },

  // Routes related to account management
  account: {
    search: `${BASE_URL}/accounts/search`,
  },

  // Routes related to institutions, Qlik roles, and parent apps
  permissions: {
    // Get institutions
    getInstitutions: `${BASE_URL}/institutions`,
    // Get Qlik roles
    getQlikRoles: `${BASE_URL}/qlikroles`,
    // Get parent apps
    getParentApps: `${BASE_URL}/parentapps`,
    createPermissions: `${BASE_URL}/permissions`,
  },
};

// Export the apiRoutes object for use in other parts of the application
export default apiRoutes;
